import { Alert, AlertDescription, AlertProps, AlertTitle, Box, BoxProps, Flex } from "@chakra-ui/react"
import { ReactElement } from "react"

type Props = {
  colorSide: string
  colorMain: string
  icon: ReactElement
  headline?: { label: string; styles?: BoxProps }
  children: ReactElement
} & AlertProps

export function AlertBox({ colorSide, colorMain, icon, headline, children, ...rest }: Props) {
  return (
    <Alert p="0" bgColor="transparent" {...rest}>
      <Flex w="100%">
        <Box py="4" px="2" bgColor={colorSide}>
          {icon}
        </Box>
        <Box p="4" bgColor={colorMain} w="100%" fontSize="sm">
          {headline?.label && <AlertTitle {...headline.styles}>{headline.label}</AlertTitle>}
          <AlertDescription>{children}</AlertDescription>
        </Box>
      </Flex>
    </Alert>
  )
}
